export default __webpack_public_path__ + "static/media/about_fabric2.6154905c.png";